import { createSelector } from 'reselect'
import layerShouldRender from '../utility/layerShouldRender'

const getLayersRendered = (state, layerName) => {
  return state.layer.layersRendered
}

const getAuthLayers = state => {
  return state.login.layers
}

const getServiceLayers = state => {
  return state.service.layers
}

const getLayerName = (state, layerName) => {
  return layerName
}

const getAuthId = (state, layerName, authId) => {
  return authId
}

const getSecondary = (state, layerName, authId, secondary) => {
  return secondary
}

export const makeGetShouldFetchDatetime = () => {
  return createSelector(
    [
      getLayersRendered,
      getAuthLayers,
      getServiceLayers,
      getLayerName,
      getAuthId,
      getSecondary
    ],
    (layersRendered, authLayers, serviceLayers, layerName, authId, secondary) => {
      const renderLayer = secondary
            ? layerShouldRender(
              layerName,
              serviceLayers,
              authLayers,
              serviceLayers,
              authId
            )
            : layerShouldRender(
        layerName,
              serviceLayers,
        authLayers,
        serviceLayers,
        authId
      )

      return renderLayer
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/shouldFetchDatetimes.js